import { EventBus } from "../../../eventbus";
import i18n from "../../../functions/i18next";

export default {
  data() {
    return {
      opperationPrefix: "file-editor-preview",
      categories: [
        {
          name: i18n.tc("common.transform", 2),
          icon: "crop",
          opperations: {
            btns: [
              {
                name: i18n.t("editor.flip_horizontal"),
                icon: "flip-horizontal",
                opperation: "flip-horizontal",
              },
              {
                name: i18n.t("editor.flip_vertical"),
                icon: "flip-vertical",
                opperation: "flip-vertical",
              },
              {
                name: "blank",
                icon: null,
                opperation: null,
              },
              {
                name: "blank2",
                icon: null,
                opperation: null,
              },
              /*{
                name: i18n.t("editor.rotate_left"),
                icon: "rotate-left",
                opperation: "rotate-left",
              },
              {
                name: i18n.t("editor.rotate_right"),
                icon: "rotate-right",
                opperation: "rotate-right",
              },*/
            ],
            sliders: [],
          },
        },
        {
          name: `${i18n.t("editor.brightness")}/${i18n.t("editor.contrast")}`,
          icon: "brightness",
          opperations: {
            btns: [],
            sliders: [
              {
                name: i18n.t("editor.brightness"),
                opperation: "brightness",
                min: -100,
                max: 100,
                defaultValue: 0,
                color: "white",
                gradient: "black-white",
              },
              {
                name: i18n.t("editor.contrast"),
                opperation: "contrast",
                min: -100,
                max: 100,
                defaultValue: 0,
                color: "white",
                gradient: "black-white",
              },
            ],
          },
        },
        {
          name: `${i18n.t("editor.hue")}/${i18n.t("editor.saturation")}`,
          icon: "hue",
          opperations: {
            btns: [],
            sliders: [
              {
                name: i18n.t("editor.hue"),
                opperation: "hue",
                min: 0,
                max: 360,
                defaultValue: 0,
                color: "white",
                gradient: "rainbow",
              },
              {
                name: i18n.t("editor.saturation"),
                opperation: "saturation",
                min: 0,
                max: 100,
                defaultValue: 0,
                color: "white",
              },
            ],
          },
        },
        {
          name: i18n.t("editor.blur"),
          icon: "lens",
          opperations: {
            btns: [],
            sliders: [
              {
                name: i18n.t("editor.blur"),
                opperation: "blur",
                min: 0,
                max: 60,
                defaultValue: 0,
                color: "white",
              },
            ],
          },
        },
      ],
      selectedCategoryIndex: 0,
    };
  },
  created() {
    EventBus.$on("file-editor-tools--reset", () => {
      this.resetAllSliders();
    });
  },
  methods: {
    resetAllSliders() {
      const resetNames = [];

      this.categories.forEach((cat) => {
        cat.opperations.sliders.forEach((slider) => {
          resetNames.push(slider.name);
        });
      });

      EventBus.$emit("vslider--reset", resetNames);
    },
    handleChangeCategory(index) {
      this.selectedCategoryIndex = index;
    },
    handlePreformOpperation(opperation) {
      EventBus.$emit(`${this.opperationPrefix}--${opperation}`);
    },
    handleInputSlider(e, opperation) {
      EventBus.$emit(`${this.opperationPrefix}--${opperation}`, e.target.value);
    },
  },
  watch: {
    selectedCategoryIndex() {},
  },
};
